import { Injectable } from '@angular/core';
import {
  getMessaging,
  getToken,
  isSupported,
  onMessage,
} from 'firebase/messaging';
import { Subscription } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { AppService } from '../../../../app.service';
import { IncomingMessage } from '../../../notification/incoming-message';
import { IncomingMessageEvent } from '../../../notification/incoming-message-event';
import { IncomingMessageEventProvider } from '../../../notification/incoming-message-event-provider';

@Injectable({
  providedIn: 'root',
})
export class NotificationApi {
  private _notificationRequestSub: Subscription;

  constructor(
    private appService: AppService,
    private incomingMessageEventProvider: IncomingMessageEventProvider,
  ) {
    // do nothing
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      appService.logger.debug('🎃 NotificationApi.afMessaging', payload);
      this.incomingMessageEventProvider.dispatch(
        new IncomingMessageEvent(new IncomingMessage(payload.data)),
      );
    });
  }

  async requestPermission(): Promise<string | undefined> {
    const supported = await isSupported();
    if (!supported) {
      console.warn('⚠️ FCM non supporté sur ce navigateur');
      return undefined;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('⚠️ Permission notifications refusée', permission);
      return undefined;
    }

    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
      );
      const messaging = getMessaging();
      const token = await getToken(messaging, {
        vapidKey: environment.vapid,
        serviceWorkerRegistration: registration,
      });
      if (token) {
        console.log('NotificationApi.token', token);
        return token;
      } else {
        throw new Error();
      }
    } catch (e) {
      console.error('🛑 NotificationApi.requestPermission', e);
      return undefined;
      // throw e;
    }
  }

  destroy() {
    this._notificationRequestSub?.unsubscribe();
  }
}
